import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuditService
{
  public revisionTypes: Array<{ text: string; key: string; value: number }> = [
    { text: 'Create', key: 'CREATE-TYPE-AUDIT', value: 0 },
    { text: 'Update', key: 'UPDATE-TYPE-AUDIT', value: 1 },
    { text: 'Delete', key: 'DELETE-TYPE-AUDIT', value: 2 }
  ];

  /**
 * Get the revision type description to use
 *
 * @param revisionType Revision Type
 * @returns string Revision Type description
 */
  public getRevisionTypeText(revisionType: number): string
  {
    let text = revisionType.toString();
    const revision = this.revisionTypes.find(x => x.value === revisionType);
    if (revision !== undefined)
    {
      text = revision.text;
    }
    return text;
  }
}
